<template>
    <div>
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <div class="section-header">
                {{ $t('pos.address_details') }}
            </div>
            <form id="address_details">
                <kt-row>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label style="margin-top: -30px" for="postal_code">
                                {{ $t('pos.postal_code') }}<span style="color: red">{{ ' *' }}</span>
                                <div style="position: absolute;top: -10px"
                                     class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                    <span class="tooltip-text">{{ $t('pos.btn_inquiry') }}</span>
                                    <i @click="postalCodeInquiry" class="fa fa-sync"
                                       style="font-size: 14px;color: #1dc9b7"></i>
                                </div>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="postal_code"
                                    name="postal_code"
                                    v-model="form_data.address_info.postal_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="8" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="shaparak_address">
                                {{ $t('pos.shaparak_address') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="rtl"
                                    id="shaparak_address"
                                    name="shaparak_address"
                                    v-model="new_address"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="guild_code">
                                {{ $t('label.subcategory_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="guild_code"
                                    name="guild_code"
                                    v-model="form_data.address_info.guild_code"
                                    class="form-control kt-selectpicker-live"
                            >
                                <option
                                        v-for="item in constants.guild_code"
                                        v-bind:key="item.GuildSupplementaryCode"
                                        :value="item.GuildSupplementaryCode">
                                    {{ item.GuildTitle }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="work_title_fa">
                                {{ $t('pos.work_title_fa') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="rtl"
                                    id="work_title_fa"
                                    name="work_title_fa"
                                    v-model="form_data.address_info.work_title_fa"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="shop_name_en">
                                {{ $t('pos.work_title_en') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="work_title_en"
                                    name="work_title_en"
                                    v-model="form_data.address_info.work_title_en"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="tax_payer_code">
                                {{ $t('label.tax_payer_code') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="tax_payer_code"
                                    name="tax_payer_code"
                                    v-model="form_data.address_info.tax_payer_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="form_data.customer_detail.is_foreign_nationals" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="business_license_end_date">
                                {{ $t('pos.business_licence_end_date') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="jDD jMMMM jYYYY"
                                    input-class="form-control"
                                    id="business_license_end_date"
                                    name="business_license_end_date"
                                    v-model="form_data.address_info.business_license_end_date"
                                    type="date"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="ownering_type">
                                {{ $t('pos.ownering_type') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="ownering_type"
                                    name="ownering_type"
                                    v-model="form_data.address_info.ownering_type"
                                    class="form-control kt-selectpicker-address"
                            >
                                <option
                                        v-for="(key,index) in constants.ownering_type"
                                        :key="key"
                                        :value="index">
                                    {{ key }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="phone_number">
                                {{ $t('pos.phone_number') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="phone_number"
                                    name="phone_number"
                                    v-model="form_data.address_info.phone_number"
                                    class="form-control"
                            ></kt-form-control>
                            <!--                            <kt-form-label style="margin-top: 5px;font-size: 9px;color: red">-->
                            <!--                                {{ $t('pos.phone_notification') }}-->
                            <!--                            </kt-form-label>-->
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.customer_detail.is_foreign_nationals" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="activity_licence_number">
                                {{ $t('pos.activity_licence_number') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="activity_licence_number"
                                    name="activity_licence_number"
                                    v-model="form_data.address_info.activity_licence_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="city_name">
                                {{ $t('label.city_name') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="city_name"
                                    name="city_shaparak_code"
                                    v-model="form_data.address_info.city_shaparak_code"
                                    class="form-control kt-selectpicker-live"
                            >
                                <option
                                        @click.prevent="afterDispatch"
                                        v-for="item in constants.city"
                                        v-bind:key="item.CityShaparakCode"
                                        :value="item.CityShaparakCode">
                                    {{ item.CityName + '(' + item.State + ')' }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>

                    <kt-col v-show="form_data.address_info.ownering_type ==1362" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="rent_ending_date">
                                {{ $t('pos.rent_ending_date') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <datePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="jDD jMMMM jYYYY"
                                    input-class="form-control"
                                    id="rent_ending_date"
                                    name="rent_ending_date"
                                    v-model="form_data.address_info.rent_ending_date"
                                    type="date"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.address_info.ownering_type == owneringType.RENTAL" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="rent_contract_no">
                                {{ $t('pos.rent_contract_no') }}
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="rent_contract_no"
                                    name="rent_contract_no"
                                    v-model="form_data.address_info.rent_contract_no"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="psp == 'NOVIN'" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="assign_type">
                                {{ $t('pos.assign_type') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="assign_type"
                                    name="assign_type"
                                    v-model="form_data.address_info.assign_type"
                                    class="form-control kt-selectpicker-address"
                            >
                                <option
                                        v-for="(item,index) in constants.assign_type"
                                        v-bind:key="index"
                                        :value="index">
                                    {{ item }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="psp == 'NOVIN'" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="trust_kind">
                                {{ $t('pos.trust_kind') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="trust_kind"
                                    name="trust_kind"
                                    v-model="form_data.address_info.trust_kind"
                                    class="form-control  kt-selectpicker-address"
                            >
                                <option
                                        :value="trustKind.CHECK">
                                    {{ $t('pos.trust_kinds.check') }}
                                </option>
                                <option
                                        :value="trustKind.CASH">
                                    {{ $t('pos.trust_kinds.cash') }}
                                </option>
                                <option
                                        :value="trustKind.ACCOUNT_BLOCKING">
                                    {{ $t('pos.trust_kinds.account_blocking') }}
                                </option>
                                <option
                                        :value="trustKind.NO_DEPOSIT">
                                    {{ $t('pos.trust_kinds.no_deposit') }}
                                </option>
                                <option
                                        :value="trustKind.REPRESENTATION_GURANTEE">
                                    {{ $t('pos.trust_kinds.presentation_gurantee') }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="psp=='NOVIN' && form_data.address_info.trust_kind == trustKind.CASH" lg="4" md="6"
                            xs="12">
                        <kt-form-group>
                            <kt-form-label for="trust_number">
                                {{ $t('pos.trust_number') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="trust_number"
                                    name="trust_number"
                                    v-model="form_data.address_info.trust_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="psp == 'NOVIN'" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="city_zone">
                                {{ $t('pos.city_zone') }}
                            </kt-form-label>
                            <kt-form-control
                                    v-model=" form_data.address_info.city_zone"
                                    dir="rtl"
                                    id="city_zone"
                                    name="city_zone"
                                    class="form-control">
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="psp == 'NOVIN'" v-show="form_data.address_info.assign_type == assignType.ON_SALE"
                            lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="cash_trust_rrn">
                                {{ $t('pos.cash_trust_rrn') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="cash_trust_rrn"
                                    name="cash_trust_rrn"
                                    v-model="form_data.address_info.cash_trust_rrn"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="psp == 'NOVIN'" lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="work_type_id">
                                {{ $t('pos.work_type_id') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <select
                                    id="work_type_id"
                                    name="work_type_id"
                                    v-model="form_data.address_info.work_type_id"
                                    class="form-control  kt-selectpicker-address"
                            >
                                <option
                                        v-for="(item,index) in constants.work_type"
                                        v-bind:key="index"
                                        :value="index">
                                    {{ item }}
                                </option>
                            </select>
                            <div class="my-4">
                            </div>
                        </kt-form-group>
                    </kt-col>

                </kt-row>
            </form>
            <kt-row v-if="form_data.status == posStatuses.ACTIVE">
                <kt-col lg="4" md="4" xs="4">
                    <kt-form-action style=" display: inline;">
                        <kt-button
                                class="m-2"
                                size="md"
                                @click="updateAddress"
                                variant="success"
                                type="submit"
                                v-bind:wide="true"
                                id="update_address"
                        >
                            {{ $t('pos.update_address') }}
                        </kt-button>
                    </kt-form-action>
                </kt-col>
            </kt-row>
        </div>
        <kt-col v-if="form_data.customer_detail.customer_type_id == customerType.LEGAL" style="padding-top: 35px" lg="4"
                md="6" xs="12">
            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="has_signature_holder"
                           name="has_signature_holder"
                           :disabled="wizard.operation != 'edit'"
                           v-model="form_data.customer_detail.has_signature_holder"
                    >
                    <label class="custom-control-label"
                           for="has_signature_holder">{{ $t('pos.has_signature_holder') }}</label>
                </div>
            </kt-form-group>
        </kt-col>
        <SignatureHolder v-if="form_data.customer_detail.has_signature_holder && psp==='PASARGAD' &&
                         form_data.customer_detail.customer_type_id===customerType.LEGAL"
                         :form_data="form_data" :wizard="wizard"></SignatureHolder>
        <kt-row>
            <kt-col lg="4" md="4" xs="5">
                <kt-form-action style=" direction: ltr; display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="step_back"
                            variant="danger"
                            type="submit"
                            v-bind:wide="true"
                            id="step_back"
                    >
                        {{ $t('label.step_back') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col lg="4" md="4" xs="2"></kt-col>
            <kt-col lg="4" md="4" xs="5">
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="next_step"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="next_step"
                    >
                        {{ $t('label.next_step') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import Inputmask from "inputmask";
import toastr from "toastr";
import {mapGetters} from "vuex";
import {owneringType, assignType, customerType, trustKind} from '@/constants/posNovin'
import SignatureHolder from "./signature-holder";
import {posService} from '@/common/api.service';
import {KTApp} from '@/plugins/core/app';
import {managerCanEditDocuments, visitorCanEditDocuments, posStatuses} from '@/constants/PosStatus';


export default {
    components: {
        SignatureHolder
    },
    name: "address-info",
    data() {
        return {
            owneringType,
            assignType,
            trustKind,
            posStatuses,
            customerType,
            shaparak_address: '',
            can_add_signature_holder: false,
            new_address: '',
        }
    },
    props: {
        wizard: {
            type: Object
        },
        form_data: {
            required: true,
        }
        ,
    },
    methods: {
        next_step() {
            let form = $('#address_details')
            let btn = $('#next_step')
            form.validate({
                lang: 'fa',
                rules: {
                    work_title_fa: {
                        required: true,
                        maxlength: 200
                    },
                    work_title_en: {
                        required: true,
                        maxlength: 200
                    },
                    postal_code: {
                        required: true,
                        digits: true,
                        minlength: 10,
                        maxlength: 10,
                    },
                    phone_number: {
                        required: true,
                    },
                    city_shaparak_code: {
                        required: true,
                    },
                    new_address: {
                        required: true,
                    },
                    guild_code: {
                        required: true,
                    },
                    ownering_type: {
                        required: true,
                    },
                    work_type_id: {
                        required: true,
                    },
                    assign_type: {
                        required: true,
                    },
                    cash_trust_rrn: {
                        required: () => {
                            if (this.form_data.address_info.assign_type === this.assignType.ON_SALE) return true; else return false
                        },
                    },
                    trust_kind: {
                        required: true,
                    },
                    tax_payer_code: {
                        required: true,
                        digits: true,
                        minlength: 10,
                        maxlength: 10,
                    },
                    trust_number: {
                        required: () => {
                            if (this.form_data.address_info.trust_kind === trustKind.CASH) return true; else return false
                        },
                    },
                    rent_contract_no: {
                        required: () => {
                            if (this.form_data.address_info.ownering_type == owneringType.RENTAL) return true; else return false
                        },
                    },
                    activity_licence_number: {
                        required: () => {
                            if (this.form_data.customer_detail.is_foreign_nationals) return true; else return false
                        },
                    },
                    rent_ending_date: {
                        required: () => {
                            if (this.form_data.address_info.ownering_type == owneringType.RENTAL) return true; else return false
                        },
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            if (!this.checkIfIsPersian(this.form_data.address_info.work_title_fa)) {
                form.validate().showErrors({
                    work_title_fa: i18n.t('pos.validations.enter_persian')
                })
                return;
            }
            if (!this.checkIfIsEnglish(this.form_data.address_info.work_title_en)) {
                form.validate().showErrors({
                    work_title_en: i18n.t('pos.validations.enter_english')
                })
                return;
            }
            if (this.form_data.customer_detail.has_signature_holder &&
                    !this.form_data.customer_detail.signature_holder) {
                this.form_data.customer_detail.has_signature_holder = false;
            }
            if (this.form_data.customer_detail.has_signature_holder) {
                let form1 = $('#signature_holder')
                form1.validate({
                    lang: 'fa',
                    rules: {
                        national_code: {
                            required: true
                        },
                        birth_date: {
                            required: true,
                        },
                        gender_id: {
                            required: true
                        },
                        last_name_fa: {
                            required: true
                        },

                        father_name_fa: {
                            required: true
                        },
                        first_name_fa: {
                            required: true
                        },
                        last_name_en: {
                            required: true
                        },

                        father_name_en: {
                            required: true
                        },
                        first_name_en: {
                            required: true
                        },
                        foreign_pervasive_code: {
                            required: () => {
                                if (this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        passport_number: {
                            required: () => {
                                if (this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        passport_expire_date: {
                            required: () => {
                                if (this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        country: {
                            required: () => {
                                if (this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        sh_birth_crtfct_number: {
                            required: () => {
                                if (!this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        sh_birth_crtfct_serial: {
                            required: () => {
                                if (!this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        sh_birth_crtfct_series_number: {
                            required: () => {
                                if (!this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        sh_birth_crtfct_series_letter: {
                            required: () => {
                                if (!this.form_data.customer_detail.signature_holder.sh_is_foreign) return true; else return false
                            }
                        },
                        mobile: {
                            required: true,
                            digits: 11
                        },
                    }
                });
                if (!form1.valid()) {
                    return
                }
            }
            this.form_data.address_info.shaparak_address = this.new_address
            this.wizard.current_step++;
        },
        step_back() {
            this.wizard.current_step--;
        },
        reloadDataTable() {

        },
        afterDispatch() {
            $('.kt-selectpicker-live').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_chose')
            });
            $('.kt-selectpicker-address').selectpicker({
                size: 6,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_chose')
            });
        },
        postalCodeInquiry() {
            this.form_data.address_info.shaparak_address = 21;
            let postal_code = this.form_data.address_info.postal_code
            postal_code = postal_code.split('-').join('')
            postal_code = postal_code.split(' ').join('')
            postal_code = postal_code.split('_').join('')
            if (postal_code.length != 10) return this.toastr.error(i18n.t('pos.message.invalid_postal_code_format'))

            posService.postalCodeInquiry(this.form_data.address_info.postal_code).then(response => {
                if (response.data.data) {
                    this.new_address = response.data.data;
                    return this.toastr.success(response.data.data)
                } else {
                    this.new_address = ''
                    return this.toastr.error(response.data.message)
                }
            }).catch(({response}) => {
                this.new_address = ''
                return this.toastr.error(i18n.t('pos.message.not_wok_temporarily'))
            })
        },
        updateAddress() {
            let form = $('#address_details')
            let btn = $('#update_address')
            form.validate({
                lang: 'fa',
                rules: {
                    postal_code: {
                        required: true,
                        digits: true,
                        minlength: 10,
                        maxlength: 10,
                    },
                    shaparak_address: {
                        required: true,
                    },
                }
            })
            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)
            let params = {
                postal_code: this.form_data.address_info.postal_code,
                shaparak_address: this.form_data.address_info.shaparak_address,
                pos_request_id: this.form_data.id,
            }
            posService.changeAddress(params).then(response => {
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            });

            KTApp.unprogress(btn)
        },
        checkIfIsPersian(value) {
            if (!value || value == 'null') return true;

            let regex = /^[\u0600-\u06FF\s]+$/;

            return regex.test(value)
        },
        checkIfIsEnglish(value) {
            if (!value || value == 'null') return true;

            let regex = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*| ']*$/;

            return regex.test(value)
        },
    },
    mounted() {
        this.afterDispatch()
        setTimeout(() => {
            document.getElementById('phone_number') && Inputmask('999-99999999')
                    .mask(document.getElementById('phone_number'))
        }, 500)
        setTimeout(() => {
            document.getElementById('postal_code') && Inputmask('9999999999')
                    .mask(document.getElementById('postal_code'))
        }, 500)

        if ((this.$can('manage', 'pos') && managerCanEditDocuments.includes(this.form_data.status)) ||
                (this.$can('update', 'pos') && visitorCanEditDocuments.includes(this.form_data.status)) ||
                (this.wizard.operation === 'create')) {
            this.can_add_signature_holder = true;
        }
        this.new_address = this.form_data.address_info.shaparak_address
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        ...mapGetters('pos', [
            'constants', 'psp'
        ])
    },
}
</script>
<style>
.kt-form-label {
    text-align: right !important;
}

.dropdown-menu {
    max-width: 600px;
}

.special-tooltip {
    position: relative;
    display: inline-block;
}

.special-tooltip .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 60px !important;
}

.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>